import React from 'react';
import { Panel } from '../panel/view/panel';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'BigPanel', 
  itemElt: (item, cmsOption) => <Panel item={item} cmsOption={cmsOption} panelType = "big__type"/>
}